import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M13.032 0.0441895C5.93998 -0.556084 0 5.03846 0 12.0016C0 18.5206 5.20799 23.803 11.652 23.9951C18.468 24.1872 24 18.7127 24 12.0016C24 5.80681 19.284 0.584435 13.032 0.0441895ZM21.516 10.8011H17.436C17.304 8.08785 16.572 5.41063 15.24 2.97353C18.576 4.17407 21.06 7.17543 21.516 10.8011ZM11.964 2.39726C11.976 2.38525 11.988 2.37326 12 2.34925C12.012 2.36125 12.024 2.37325 12.036 2.39726C13.884 4.9064 14.88 7.82373 15.048 10.8011H8.964C9.12 7.83573 10.128 4.9064 11.964 2.39726ZM8.74801 2.97353C7.41601 5.41063 6.696 8.08785 6.564 10.8011H2.48401C2.94001 7.17543 5.41201 4.18608 8.74801 2.97353ZM2.48401 13.2022H6.58799C6.82799 15.9994 7.71601 18.7367 9.24002 21.1978C5.66401 20.1173 2.96401 17.0079 2.48401 13.2022ZM12.012 21.0057C10.284 18.6647 9.264 15.9754 9 13.2022H15.012C14.748 15.9634 13.728 18.6647 12.012 21.0057ZM14.772 21.1978C16.296 18.7367 17.172 15.9994 17.412 13.2022H21.516C21.036 16.9959 18.348 20.1173 14.772 21.1978Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
